import { Component, Input, OnInit } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { DataAnalyticsClickSource, MbConstants } from '../../../../shared/mb-constants'
import { SearchUtilsService } from '../../../services/search-utils.service'
import { UrlUtils } from '../../../../shared/utils/url-utils'
import { VariantOption } from '@spartacus/core'
import { sortStamps } from '../../../../shared/utils/stamps-utils'

@Component({
  selector: 'mb-search-result-item',
  templateUrl: './mb-search-result-item.component.html',
  styleUrls: ['./mb-search-result-item.component.scss']
})
export class MbSearchResultItemComponent implements OnInit {

  @Input() model: VariantOption | undefined
  @Input() isChild = false
  stamps: string[] = []
  constants = MbConstants
  isFacetExpanded$ = this.searchFilterService.isFacetsExpanded$
  url: string | undefined
  fragment: string | undefined

  addToCartForm = new UntypedFormGroup({
    quantity: new UntypedFormControl(1, { updateOn: 'blur' }),
  })

  dataAnalyticsClickSource = DataAnalyticsClickSource.LIST

  constructor (private searchFilterService: SearchUtilsService) {
  }

  ngOnInit () {
    this.stamps = sortStamps(this.model?.stamps)
    this.url = UrlUtils.getPath(this.model?.url)?.toLowerCase()
    this.fragment = UrlUtils.getFragment(this.model?.url)?.toLowerCase()
  }

  get hasPriceOnRequest () {
    return this.model?.priceOnRequest
  }
}
